import { useEffect, useRef, useState } from "react";

type StageSize = { width: number; height: number };

export function stageSizeFor(
  mode: "rect" | "square",
  width: number,
  height: number,
): StageSize {
  return mode === "square"
    ? { width: Math.min(width, height), height: Math.min(width, height) }
    : { width, height };
}

/**
 * Container-Größe per `ResizeObserver`. `"square"` liefert die kürzere Kante
 * als Breite und Höhe, damit eine 0–1000-Karte unverzerrt bleibt. `"rect"`
 * bleibt für rechteckige, nicht-kartenbezogene Flächen verfügbar.
 */
export function useStageSize(
  mode: "rect" | "square",
  initial: StageSize = { width: 900, height: 670 },
): { containerRef: React.RefObject<HTMLDivElement | null>; size: StageSize } {
  const containerRef = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<StageSize>(() =>
    stageSizeFor(mode, initial.width, initial.height),
  );
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const observer = new ResizeObserver(([entry]) => {
      if (!entry) return;
      const { width, height } = entry.contentRect;
      setSize(stageSizeFor(mode, width, height));
    });
    observer.observe(container);
    return () => observer.disconnect();
  }, [mode]);
  return { containerRef, size };
}
